import React, { ReactElement, useState } from 'react'
import { orderBy } from 'lodash'
import { Cards } from '../../styled-components'

/* import { deleteCategory } from '../../../../api/Category' */
import { Category, TrainingGroup } from '../../../../types/training'
/* import { Alert } from '../../../../constants/sweet-alert' */
import CategoryAddEdit from '../add-edit-category'
import Card from '../../card'
import AdminTemplate from '../../../base-template'
import { Alert } from '../../../../constants/sweet-alert'
import { deleteCategory } from '../../../../api/category'
import DeleteModal from '../../../delete-modal'

interface CategoryCardsProps {
  trainingsGroup: TrainingGroup
}

const CategoryCards = ({
  trainingsGroup,
}: CategoryCardsProps): ReactElement => {
  const training = trainingsGroup.trainings[0]
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false)
  const [categories, setAllCategories] = useState<Category[] | undefined>(
    trainingsGroup.trainings[0].categories
  )
  const [editCategory, setEditCategory] = useState<Category | undefined>(
    undefined
  )
  const [deletedCategory, setDeletedCategory] = useState<Category>()
  const [addCategory, setAddCategory] = useState<
    Omit<Category, 'parts' | 'status'> | undefined
  >(undefined)

  const removeCategory = () => {
    setLoadingDelete(true)
    deleteCategory(deletedCategory?.id).then((result) => {
      if (result === 200) {
        const findCategoryIndex = categories?.findIndex(
          (el) => el.id === deletedCategory?.id
        )
        const oldCategories = categories
        oldCategories?.splice(findCategoryIndex as number, 1)
        setAllCategories(oldCategories)
        setDeletedCategory(undefined)
        Alert.fire({
          icon: 'success',
          title: `Deleted`,
        })
      } else {
        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
      setLoadingDelete(false)
    })
  }

  return (
    <>
      {deletedCategory ? (
        <DeleteModal
          onCancel={() => setDeletedCategory(undefined)}
          title={deletedCategory.title}
          onDelete={() => removeCategory()}
          loadingDelete={loadingDelete}
        />
      ) : null}
      <AdminTemplate
        onAddClick={() =>
          setAddCategory({
            id: '',
            title: '',
            placement: (categories?.length || 0) + 1,
          })
        }
        navigation={[
          {
            title: trainingsGroup.title,
            link: `/trainings?type=${trainingsGroup.name}`,
          },
          {
            title: training.title,
            link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}`,
          },
        ]}
        adminTemplate
      >
        {addCategory ? (
          <CategoryAddEdit
            onClose={() => setAddCategory(undefined)}
            category={addCategory}
            trainingId={training?.id}
          />
        ) : editCategory ? (
          <CategoryAddEdit
            onClose={() => setEditCategory(undefined)}
            category={editCategory}
          />
        ) : (
          <>
            <Cards>
              {orderBy(categories, ['placement']).map((category) => (
                <Card
                  key={category.id}
                  element={category}
                  onClickEdit={(c) => setEditCategory(c as unknown as Category)}
                  onDeleteClick={(c) =>
                    setDeletedCategory(c as unknown as Category)
                  }
                  link={`/trainings?type=${trainingsGroup.name}&training_id=${training?.id}&category_id=${category.id}`}
                />
              ))}
            </Cards>
          </>
        )}
      </AdminTemplate>
    </>
  )
}

export default CategoryCards
